import React from 'react'

const ReTable = ({ children }) => (
  <div className="table-responsive">
    <table className="table">{children}</table>
  </div>
)

export default ReTable
